/* Hook encargado de hacer la consulta a la base y 
traer la Nota de venta

Autor: Benjamín León
Fecha: 2024-08-16

*/
import { useState } from 'react'

import { formatDateToYYYY_MM_DD } from '../utils/utils.ts'
import { customFetch } from '../utils/customFetch.ts'
import { Salenote } from '../interfaces/Salenote.ts'

import { makeUrlSalenote, makeUrlSalenoteTradeIn } from './connectionData.tsx'

// Para acomodar los campos que son de Salenotes

const useSalenoteFetcher = () => {
  const [errorSalenote, setErrorSalenote] = useState<Error | null>(null)
  const [loading, setLoading] = useState<boolean>(false)

  const fetchSalenote = async (id: string) => {
    setLoading(true)

    try {
      const data = await fetchDatabase(id)
      setErrorSalenote(null)

      return data
    } catch (err) {
      // Assert the error as an instance of Error
      if (err instanceof Error) {
        setErrorSalenote(err)
      } else {
        setErrorSalenote(new Error('An unknown error occurred'))
      }

      return null
    } finally {
      setLoading(false)
    }
  }
  const fetchDatabase = async (id: string): Promise<Salenote> => {
    const apiUrl = makeUrlSalenote(id)

    // Fetching documents from the collection and converting them into an array
    const data = await customFetch<Salenote>(apiUrl)

    const notes = Array.isArray(data.notes) ? (data.notes ?? []).join('\n') : data.notes
    const payments = (data.payments ?? []).map((p) => {
      return { ...p, date: formatDateToYYYY_MM_DD(new Date(p.date)) }
    })
    const additionals = (data.additionals ?? []).map((p) => {
      return { ...p, date: formatDateToYYYY_MM_DD(new Date(p.date)) }
    })
    const hayRv = data.reservation && data.body.reservation
    const paymentsRv = hayRv
      ? (data.body.reservation?.payments ?? []).map((p) => {
          return { ...p, date: formatDateToYYYY_MM_DD(new Date(p.date)) }
        })
      : []

    // Esto es para tener "inmutabilidada" en variables
    // Creamos variable nueva en vez de modificar "data"
    const datanew = {
      ...data,
      date: formatDateToYYYY_MM_DD(new Date(data.date)),
      payments: payments,
      additionals: additionals,
      notes: notes,
    }

    if (hayRv) {
      if (datanew.body.reservation) {
        datanew.body.reservation.payments = paymentsRv
      }
    }

    return datanew
  }
  const fetchSalenoteTradeIn = async (plate: string) => {
    setLoading(true)

    try {
      const apiUrl = makeUrlSalenoteTradeIn(plate)

      // Fetching documents from the collection and converting them into an array
      const data = await customFetch<Salenote>(apiUrl)

      setErrorSalenote(null)

      return data
    } catch (err) {
      // Assert the error as an instance of Error
      if (err instanceof Error) {
        setErrorSalenote(err)
      } else {
        setErrorSalenote(new Error('An unknown error occurred'))
      }

      return null
    } finally {
      setLoading(false)
    }
  }

  // Exponemos estas variables al exterior
  return { errorSalenote, loading, fetchSalenote, fetchSalenoteTradeIn }
}
export default useSalenoteFetcher
